import { render, staticRenderFns } from "./tabUsCustomsClearanceItem.vue?vue&type=template&id=315bb18c&scoped=true&"
import script from "./tabUsCustomsClearanceItem.vue?vue&type=script&lang=js&"
export * from "./tabUsCustomsClearanceItem.vue?vue&type=script&lang=js&"
import style0 from "./tabUsCustomsClearanceItem.vue?vue&type=style&index=0&id=315bb18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315bb18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315bb18c')) {
      api.createRecord('315bb18c', component.options)
    } else {
      api.reload('315bb18c', component.options)
    }
    module.hot.accept("./tabUsCustomsClearanceItem.vue?vue&type=template&id=315bb18c&scoped=true&", function () {
      api.rerender('315bb18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceItem.vue"
export default component.exports